import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { FcOutlinedSelectModule } from '../../base/fc-outlined-select/fc-outlined-select.module';
import { FcCompanyOutlinedSelectComponent } from './fc-company-outlined-select.component';

@NgModule({
  declarations: [
    FcCompanyOutlinedSelectComponent
  ],
  imports: [
    CommonModule,
    FuseSharedModule,
    FcOutlinedSelectModule
  ],
  providers: [],
  exports: [
    FcCompanyOutlinedSelectComponent
  ]
})
export class FcCompanyOutlinedSelectModule { }
